import React, { useRef } from "react";
import { CTAButton } from "./UI";
import { useScrollReveal } from "../hooks";

export default function BigCTA() {
  const ref = useRef(null);
  const visible = useScrollReveal(ref);

  return (
    <section className={"big-cta reveal-section" + (visible ? " revealed" : "")} ref={ref}>
      <div className="container big-cta-inner">
        <div className="big-cta-left reveal-child" style={{ transitionDelay: "0s" }}>
          <span className="big-cta-eyebrow">Ready to grow?</span>
          <h2>Let's build something your customers can't ignore.</h2>
          <p className="lede">
            Whether you need a brand, a website, content or a full growth strategy — we'll figure out exactly what your business needs and build it.
          </p>
        </div>
        <div className="big-cta-right reveal-child" style={{ transitionDelay: "0.18s" }}>
          <CTAButton href="#contact">Start a conversation</CTAButton>
          <div className="big-cta-note">
            No commitment. Just a conversation about your business.
          </div>
        </div>
      </div>
    </section>
  );
}
